import { useState } from "react";

export const useCollapsible = (initialExpanded = false) => {
    const [isExpanded, setIsExpanded] = useState(initialExpanded);

    const handleToggle = () => setIsExpanded((prev) => !prev);

    const handleKeyDown = (e: React.KeyboardEvent) => {
        if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            handleToggle();
        }
    };

    return { isExpanded, handleToggle, handleKeyDown, setIsExpanded };
};
